/* 
  项目信息管理
*/
import request from "@/utils/request";

//获取项目信息管理分页列表
export function getProjectMsg(params) {
  return request({
    url: "/baseinfo/projectMsgManage/getProjectMsg",
    method: "get",
    params
  });
}

//保存或编辑项目信息
export function saveOrUpdate(data) {
  return request({
    url: "/baseinfo/projectMsgManage/saveOrUpdate",
    method: "post",
    data
  });
}

//获取项目信息管理页面参数
export function getParam() {
  return request({
    url: "/baseinfo/projectMsgManage/getParam",
    method: "get"
  });
}

//删除项目信息
export function deleteProjectMsg(data) {
  return request({
    url: "/baseinfo/projectMsgManage/deleteProjectMsg",
    method: "post",
    data
  });
}
